import React, { useEffect, useState } from "react";
import PageHeader from "../../../components/common/PageHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faEllipsisV,
    faPlus,
    faEye,
    faEdit,
    faBan,
    faSort, faSortUp, faSortDown
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { getClientList } from "../api/clientService";

interface Client {
    id: number;
    name: string;
    city: string;
    state: string;

    primary_contact_name?: string | null;
    primary_contact_mobile?: string | null;
    primary_contact_email?: string | null;
}

const ClientList: React.FC = () => {
    const navigate = useNavigate();

    const [clients, setClients] = useState<Client[]>([]);

    // pagination (same as HR)
    const [page, setPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [filters, setFilters] = useState({
        name: "",
        city: "",
        state: "",
        contactName: "",
        contactMobile: "",
        contactEmail: "",
    });

    const [ordering, setOrdering] = useState("");
    const [pageSize, setPageSize] = useState<number | null>(null);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [isFetching, setIsFetching] = useState(false);
    const [debouncedFilters, setDebouncedFilters] = useState(filters);
    // row action dropdown
    const [openActionId, setOpenActionId] = useState<number | null>(null);
    const getSortIcon = (field: string) => {
        if (ordering === field) return faSortUp;
        if (ordering === `-${field}`) return faSortDown;
        return faSort;
    };

    const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0 });
    const toggleOrdering = (field: string) => {
        setOrdering(prev => {
            if (prev === field) return `-${field}`;
            if (prev === `-${field}`) return "";
            return field;
        });
    };

    /* =====================
       FETCH CLIENTS
    ===================== */
    // const fetchClients = async (pageNo: number, appliedFilters = filters) => {
    //     if (isInitialLoad) setIsInitialLoad(true);
    //     else setIsFetching(true);

    //     try {
    //         const res = await getClientList(pageNo, {
    //             name__icontains: appliedFilters.name,
    //             city__icontains: appliedFilters.city,
    //             contact: appliedFilters.contact,
    //             ordering,
    //         });


    //         const results = res.data?.results || [];

    //         const enrichedClients = await Promise.all(
    //             results.map(async (client: any) => {
    //                 try {
    //                     const contactRes = await getClientContacts(client.id);
    //                     const master = contactRes.data?.results?.find(
    //                         (c: any) => c.is_master
    //                     );

    //                     return {
    //                         ...client,
    //                         primaryContact: master
    //                             ? { name: master.name, mobile: master.mobile_no }
    //                             : undefined,
    //                     };
    //                 } catch {
    //                     return client;
    //                 }
    //             })
    //         );

    //         setClients(enrichedClients);
    //         setTotalCount(res.data?.count || 0);

    //         if (pageSize === null && results.length) {
    //             setPageSize(results.length);
    //         }
    //     } finally {
    //         setIsFetching(false);
    //         setIsInitialLoad(false);
    //     }
    // };


    const fetchClients = async (pageNo: number, appliedFilters = filters) => {
        if (isInitialLoad) setIsInitialLoad(true);
        else setIsFetching(true);

        try {
            const res = await getClientList(pageNo, {
                name__icontains: appliedFilters.name,
                city__icontains: appliedFilters.city,
                state__icontains: appliedFilters.state,

                // ✅ UPDATED KEYS
                primary_contact_name: appliedFilters.contactName,
                primary_contact_mobile: appliedFilters.contactMobile,
                primary_contact_email: appliedFilters.contactEmail,

                ordering,
            });

            const results = res.data?.results || [];

            setClients(results);
            setTotalCount(res.data?.count || 0);

            if (pageSize === null && results.length) {
                setPageSize(results.length);
            }
        } finally {
            setIsFetching(false);
            setIsInitialLoad(false);
        }
    };
    useEffect(() => {
        fetchClients(page, debouncedFilters);
    }, [page, ordering, debouncedFilters]);
    useEffect(() => {
        const debounce = setTimeout(() => {
            setDebouncedFilters(filters);
            setPage(1);
        }, 500);

        return () => clearTimeout(debounce);
    }, [filters]);

    /* =====================
       PAGINATION
    ===================== */
    const totalPages =
        pageSize && totalCount
            ? Math.ceil(totalCount / pageSize)
            : 1;

            useEffect(() => {
  const close = () => setOpenActionId(null);
  document.addEventListener("click", close);
  return () => document.removeEventListener("click", close);
}, []);
useEffect(() => {
  const handleScroll = () => setOpenActionId(null);
  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, []);
return (
        <>
            {/* ===== PAGE HEADER ===== */}
            <PageHeader
                title="Client Master"
                breadcrumbs={[
                    { label: "Dashboard", path: "/dashboard" },
                    { label: "Masters" },
                    { label: "Client Master" },
                ]}
            />

            {/* ===== TABLE ===== */}
            <div className="container mt-4">
                <div className="d-flex align-items-center justify-content-end mb-4">
                    <button
                        className="btn btn-primary"
                        onClick={() => navigate("/masters/client/create")}
                    >
                        <FontAwesomeIcon icon={faPlus} /> Add Client
                    </button>
                </div>
                <div className="card hr-card">
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0">
                            <thead>
                                <tr>
                                    <th>Action</th>

                                    <th onClick={() => toggleOrdering("name")} className="sortable">
                                        Name <FontAwesomeIcon icon={getSortIcon("name")} />
                                    </th>

                                    <th>Contact Name</th>
                                    <th>Mobile</th>
                                    <th>Email</th>

                                    <th onClick={() => toggleOrdering("city")} className="sortable">
                                        City <FontAwesomeIcon icon={getSortIcon("city")} />
                                    </th>

                                    <th onClick={() => toggleOrdering("state")} className="sortable">
                                        State <FontAwesomeIcon icon={getSortIcon("state")} />
                                    </th>
                                </tr>
                                <tr className="table-filter-row">
                                    <th></th>

                                    <th>
                                        <input
                                            className="form-control form-control-sm"
                                            placeholder="Search name..."
                                            value={filters.name}
                                            onChange={(e) =>
                                                setFilters(prev => ({ ...prev, name: e.target.value }))
                                            }
                                        />
                                    </th>


                                    <th>
                                        <input
                                            className="form-control form-control-sm"
                                            placeholder="Search contact..."
                                            value={filters.contactName}
                                            onChange={(e) =>
                                                setFilters(prev => ({ ...prev, contactName: e.target.value }))
                                            }
                                        />
                                    </th>

                                    <th>
                                        <input
                                            className="form-control form-control-sm"
                                            placeholder="Search mobile..."
                                            value={filters.contactMobile}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                if (val === "" || /^\d+$/.test(val)) {
                                                    setFilters(prev => ({ ...prev, contactMobile: val }));
                                                }
                                            }}
                                        />
                                    </th>

                                    <th>
                                        <input
                                            className="form-control form-control-sm"
                                            placeholder="Search email..."
                                            value={filters.contactEmail}
                                            onChange={(e) =>
                                                setFilters(prev => ({ ...prev, contactEmail: e.target.value }))
                                            }
                                        />
                                    </th>

                                    <th>
                                        <input
                                            className="form-control form-control-sm"
                                            placeholder="Search city..."
                                            value={filters.city}
                                            onChange={(e) =>
                                                setFilters(prev => ({ ...prev, city: e.target.value }))
                                            }
                                        />
                                    </th>

                                    <th>
                                        <input
                                            className="form-control form-control-sm"
                                            placeholder="Search state..."
                                            value={filters.state}
                                            onChange={(e) =>
                                                setFilters(prev => ({ ...prev, state: e.target.value }))
                                            }
                                        />
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {isInitialLoad ? (
                                    <tr>
                                        <td colSpan={7} className="text-center py-4">
                                            Loading...
                                        </td>
                                    </tr>
                                ) : clients.length === 0 ? (
                                    <tr>
                                        <td colSpan={7} className="text-center py-4">
                                            No clients found
                                        </td>
                                    </tr>
                                ) : (
                                    clients.map(client => (
                                        <tr key={client.id}>
                                            <td className="position-relative">
                                                <FontAwesomeIcon
                                                    icon={faEllipsisV}
                                                    className="text-muted cursor-pointer"
                                                    onClick={(e) => {
                                                        e.stopPropagation();

                                                        const rect = e.currentTarget.getBoundingClientRect();

                                                        const DROPDOWN_WIDTH = 140;
                                                        const PADDING = 8;

                                                        let left = rect.right - DROPDOWN_WIDTH;

                                                        if (left < PADDING) {
                                                            left = PADDING;
                                                        }

                                                        setDropdownPos({
                                                            top: rect.bottom + 6,
                                                            left,
                                                        });

                                                        setOpenActionId(openActionId === client.id ? null : client.id);
                                                    }}

                                                />

                                                {openActionId && (
  <div
    className="inquiry-action-dropdown fixed"
    style={{
      top: dropdownPos.top,
      left: dropdownPos.left,
    }}
    onClick={(e) => e.stopPropagation()}
  >
    <button onClick={() => {
      navigate(`/masters/client/view/${openActionId}`);
      setOpenActionId(null);
    }}>
      View
    </button>

    <button onClick={() => {
      navigate(`/masters/client/edit/${openActionId}`);
      setOpenActionId(null);
    }}>
      Edit
    </button>
  </div>
)}
                                            </td>

                                            <td>{client.name}</td>

                                            <td>
                                                {client.primary_contact_name || (
                                                    <span className="text-muted">—</span>
                                                )}
                                            </td>

                                            <td>
                                                {client.primary_contact_mobile || (
                                                    <span className="text-muted">—</span>
                                                )}
                                            </td>

                                            <td>
                                                {client.primary_contact_email || (
                                                    <span className="text-muted">—</span>
                                                )}
                                            </td>

                                            <td>{client.city || <span className="text-muted">—</span>}</td>

                                            <td>{client.state || <span className="text-muted">—</span>}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* ===== PAGINATION ===== */}
                    {totalPages > 1 && (
                        <div className="d-flex gap-1 justify-content-end p-3">
                            <button
                                className="btn btn-sm btn-outline-secondary"
                                disabled={page === 1}
                                onClick={() => setPage(page - 1)}
                            >
                                Prev
                            </button>

                            {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
                                <button
                                    key={p}
                                    className={`btn btn-sm ${p === page ? "btn-primary" : "btn-outline-secondary"
                                        }`}
                                    onClick={() => setPage(p)}
                                >
                                    {p}
                                </button>
                            ))}

                            <button
                                className="btn btn-sm btn-outline-secondary"
                                disabled={page === totalPages}
                                onClick={() => setPage(page + 1)}
                            >
                                Next
                            </button>
                        </div>
                    )}

                </div>
            </div>
        </>
    );
};

export default ClientList;
